import React from 'react';
import type { ImportJob } from '../../../services/importJobService';
import { useRecentActivationJobs } from '../hooks/useActivationJob';

interface RecentActivationJobsProps {
  onOpen: (jobId: string) => void;
}

const statusText = (job: ImportJob) => {
  switch (job.status) {
    case 'queued':
      return 'Đang chờ xử lý';
    case 'processing':
      return `Đang chạy ${job.processed_rows}/${job.total_rows} dòng`;
    case 'completed':
      return `Hoàn tất ${job.processed_rows}/${job.total_rows} dòng`;
    default:
      return 'Bị dừng';
  }
};

const statusClass: Record<ImportJob['status'], string> = {
  queued: 'text-yellow-700',
  processing: 'text-blue-700',
  completed: 'text-green-700',
  failed: 'text-red-700',
};

const formatTime = (iso?: string | null) => (iso ? new Date(iso).toLocaleString('vi-VN') : '');

// Vào trang từ menu (không có ?job=) vẫn tìm lại được job đang chạy, khỏi upload lại cùng file
const RecentActivationJobs: React.FC<RecentActivationJobsProps> = ({ onOpen }) => {
  const { data: jobs } = useRecentActivationJobs(true);

  if (!jobs || jobs.length === 0) return null;

  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-3">Lần kích hoạt gần đây</h3>
      <ul className="divide-y divide-gray-200">
        {jobs.map((job) => (
          <li key={job.id} className="py-3 flex items-center justify-between gap-4">
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{job.file_name}</p>
              <p className="text-xs text-gray-500">
                {formatTime(job.created_at)}
                {job.created_at && ' · '}
                <span className={statusClass[job.status]}>{statusText(job)}</span>
                {job.status === 'completed' && job.error_rows > 0 && `, ${job.error_rows} lỗi`}
              </p>
            </div>
            <button
              onClick={() => onOpen(job.id)}
              className="shrink-0 px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
              Xem
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentActivationJobs;
